<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>已采购但出库前取消</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主内容容器 -->
    <div class="content-container">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="店铺">
          <el-select v-model="formInline.shopIds" placeholder="店铺" clearable multiple style="width: 80px;">
            <el-option v-for="shop in shopList" :key="shop.id" :label="shop.shopName" :value="shop.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderSn" placeholder="订单号" clearable style="width: 90px;"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <dict-select v-model="formInline.erpPlatform" category-id="ERP_PLATFORM" placeholder="平台" clearable style="width: 100px;"></dict-select>
        </el-form-item>
        <el-form-item label="处理状态">
          <dict-select v-model="formInline.applyStatusList" category-id="REFUND_APPLY_STATUS" placeholder="处理状态"
            style="width: 110px" :multiple="true">
          </dict-select>
        </el-form-item>
        <el-form-item label="处理结果">
          <dict-select v-model="formInline.resultStatusList" category-id="REFUND_RESULT_STATUS" placeholder="处理结果"
            style="width: 110px" :multiple="true">
          </dict-select>
        </el-form-item>
        <el-form-item label="结算状态">
          <dict-select v-model="formInline.settlementFlagList" category-id="SETTLEMENT_STATUS" placeholder="结算状态"
            style="width: 110px" :multiple="true">
          </dict-select>
        </el-form-item>
        <el-form-item label="填写人">
          <user-selector v-model="selectedResultUsers" :multiple="true" placeholder="请选择填写人" style="width: 120px;" @select="handleResultUserSelect">
          </user-selector>
        </el-form-item>
        <el-form-item label="处理时间">
          <el-date-picker v-model="formInline.resultTimeRange" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd" style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
          <!-- <el-button type="warning" icon="el-icon-download" @click="handleExport">下载</el-button> -->
        </el-form-item>
      </el-form>

      <!-- 数据表格 - 嵌套展示 -->
      <el-table
        ref="table"
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        :row-key="getRowKey"
        :expand-row-keys="expandedRows"
        @expand-change="handleExpandChange"
        @sort-change="handleSortChange">
        
        <!-- 展开行 - 显示订单明细退款信息 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="refund-items-section">
              <el-table :data="scope.row.refundItems" border style="width: 100%;">
                <el-table-column prop="itemImage" label="商品图片" width="100" align="center">
                  <template slot-scope="item">
                    <img :src="item.row.itemImage || '/static/img/default-product.png'"
                      style="width: 55px; height: 55px; object-fit: cover; border-radius: 4px;"
                      @error="handleImageError" />
                  </template>
                </el-table-column>
                <el-table-column prop="itemName" label="商品名称" width="140" align="center">
                  <template slot-scope="item">
                    <el-popover
                      placement="top"
                      width="300"
                      trigger="hover"
                      :disabled="!item.row.itemName">
                      <div slot="reference" class="item-name-cell">
                        <span class="item-name-text clickable-item-name"
                              @click="copyItemName(item.row.itemName)"
                              :title="'点击复制商品名称: ' + item.row.itemName">{{ item.row.itemName }}</span>
                      </div>
                      <!-- Popover内容 -->
                      <div class="item-preview-content">
                        <div class="item-image-section">
                          <img :src="item.row.itemImage || '/static/img/default-product.png'"
                               style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; border: 1px solid #e4e7ed;"
                               @error="handleImageError" />
                        </div>
                        <div class="item-info-section">
                          <div class="item-detail-row">
                            <span class="item-label">商品名称：</span>
                            <span class="item-value">{{ item.row.itemName || '-' }}</span>
                          </div>
                          <div class="item-detail-row">
                            <span class="item-label">商品规格：</span>
                            <span class="item-value">{{ item.row.itemModelName || '-' }}</span>
                          </div>
                        </div>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="数量" width="80" align="center"></el-table-column>
                <dict-table-column prop="purchaseChannel" label="采购途径" width="100" align="center" category-id="PURCHASE_CHANNEL"></dict-table-column>
                <el-table-column prop="purchaseAmount" label="采购金额" width="100" align="center">
                  <template slot-scope="item">
                    <span>{{ formatAmount(item.row.purchaseAmount) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="purchaseUserName" label="采购人" width="100" align="center">
                  <template slot-scope="item">
                    {{ item.row.purchaseUserName || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="purchaseDate" label="采购日期" width="100" align="center"></el-table-column>
                <dict-table-column prop="applyStatus" label="处理状态" width="130" align="center" category-id="REFUND_APPLY_STATUS"></dict-table-column>
                <el-table-column prop="applyDetail" label="处理详情" width="120" align="center">
                  <template slot-scope="item">
                    <div v-if="item.row.applyStatus === '1'" style="text-align: center;">
                      <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                          <div>申请金额：{{ formatAmount(item.row.applyAmount) }}</div>
                          <div>填写时间：{{ formatDate(item.row.applyTime) }}</div>
                          <div>填写人：{{ item.row.applyUserName }}</div>
                        </div>
                        <div style="cursor: pointer;">{{ formatAmount(item.row.applyAmount)}}</div>
                      </el-tooltip>
                    </div>
                    <span v-else style="color: #909399;">-</span>
                  </template>
                </el-table-column>
                <dict-table-column prop="resultStatus" label="处理结果" align="center" width="90" category-id="REFUND_RESULT_STATUS"></dict-table-column>
                <el-table-column prop="resultDetail" label="结果详情" width="120" align="center">
                  <template slot-scope="item">
                    <!-- 退款成功 -->
                    <div v-if="item.row.resultStatus === '1'" style="text-align: center;">
                      <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                          <div>退款金额：{{ formatAmount(item.row.refundSuccessAmount) }}</div>
                          <div>处理时间：{{ formatDate(item.row.resultTime) }}</div>
                          <div>处理人：{{ item.row.resultUserName }}</div>
                        </div>
                        <div style="color: #A1C65C; font-weight: bold; cursor: pointer;">{{ formatAmount(item.row.refundSuccessAmount)}}</div>
                      </el-tooltip>
                    </div>
                    <!-- 退款失败 -->
                    <div v-else-if="item.row.resultStatus === '2'" style="text-align: center;">
                      <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                          <div>失败原因：{{ item.row.refundFailReason }}</div>
                          <div>处理时间：{{ formatDate(item.row.resultTime) }}</div>
                          <div>处理人：{{ item.row.resultUserName }}</div>
                        </div>
                        <div style="color: #F56C6C; font-weight: bold; cursor: pointer;">{{ item.row.refundFailReason || '退款失败' }}</div>
                      </el-tooltip>
                    </div>
                    <!-- 已入库 -->
                    <div v-else-if="item.row.resultStatus === '3'" style="text-align: center;">
                      <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                          <div>确认时间：{{ formatDate(item.row.resultTime) }}</div>
                          <div>确认人：{{ item.row.resultUserName }}</div>
                        </div>
                        <div style="color: #4CA0FF; font-weight: bold; cursor: pointer;">已入库</div>
                      </el-tooltip>
                    </div>
                    <!-- 无结果状态 -->
                    <span v-else style="color: #909399;">-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="resultUserName" label="填写人" align="center" width="80">
                  <template slot-scope="item">
                    {{ item.row.resultUserName || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="resultTime" label="处理时间" align="center" width="140">
                  <template slot-scope="item">
                    {{ formatDate(item.row.resultTime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="settlementFlag" label="结算状态" width="100" align="center">
                  <template slot-scope="item">
                    <span v-if="item.row.resultStatus == null">-</span>
                    <span v-else-if="item.row.settlementFlag === '-1'"><el-tag type="info">无需结算</el-tag></span>
                    <span v-else-if="item.row.settlementFlag === '0'"><el-tag type="warning">待结算</el-tag></span>
                    <span v-else-if="item.row.settlementFlag === '1'"><el-tag type="success">已结算</el-tag></span>
                    <span v-else><el-tag type="info">无需结算</el-tag></span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="200" align="center">
                  <template slot-scope="item">
                    <el-button v-permission="['ord-refund:apply']" v-if="item.row.applyStatus !== '2' && item.row.resultStatus !== '1'" size="mini" type="text" @click="handleItemApply(item.row)">
                      <i class="el-icon-edit"></i> 处理
                    </el-button>
                    <el-button v-permission="['ord-refund:result']" v-if="item.row.applyStatus === '1' && item.row.resultStatus !== '1'" size="mini" type="text" @click="handleItemResult(item.row)">
                      <i class="el-icon-data-analysis"></i> 结果
                    </el-button>
                    <el-button v-permission="['ord-refund:confirm']" v-if="item.row.applyStatus === '2' && item.row.resultStatus == null" size="mini" type="text" @click="handleItemConfirmPutIn(item.row)">
                      <i class="el-icon-check"></i> 确认入库
                    </el-button>
                    <el-button v-permission="['ord-refund:delete']" v-if="item.row.applyStatus !== '0' && item.row.resultStatus == null" size="mini" type="text" @click="handleItemDelete(item.row)" style="color: #F56C6C;">
                      <i class="el-icon-delete"></i> 删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="shopName" label="店铺名称" width="150" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单号" width="160" align="center">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: bold; cursor: pointer;"
              @click="copyOrderSn(scope.row.orderSn)" :title="'点击复制订单号'">
              {{ scope.row.orderSn }}
            </span>
          </template>
        </el-table-column>
        <dict-table-column prop="erpPlatform" label="平台" category-id="ERP_PLATFORM" width="80" align="center">
        </dict-table-column>
        <!-- <dict-table-column prop="orderStates" label="订单状态" category-id="ERP_ORDER_STATUS" width="100" align="center">
        </dict-table-column> -->
        <!-- <dict-table-column prop="orderStates" label="订单状态" width="100" align="center" category-id="ORDER_STATES">
        </dict-table-column> -->
        <el-table-column prop="createTime" label="下单时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="outTime" label="出库时间" width="140" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.outTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="totalPrice" label="订单总金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: bold;">{{ scope.row.totalPrice ? scope.row.totalPrice.toFixed(2) : '0.00' }}</span>
          </template>
        </el-table-column> -->

        <!-- 使用NoteColumn组件 -->
        <NoteColumn :current-scene="currentScene" width="350"/>

        <el-table-column label="操作" min-width="80" align="left">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openNotesDrawer(scope.row)" icon="el-icon-tickets">备注</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <Pagination v-bind:child-msg="pageParam" @callback_getPageData="callback_getPageData"></Pagination>
    </div>

    <!-- 申请弹窗 -->
    <OrdRefundEdit
      :visible="refundDialogVisible"
      :edit-data="currentRefundData"
      :is-edit="isEditRefund"
      @close="handleRefundDialogClose"
      @success="handleRefundSuccess"
    />

    <!-- 结果弹窗 -->
    <OrdRefundResultEdit
      :visible="resultDialogVisible"
      :edit-data="currentRefundData"
      @close="handleResultDialogClose"
      @success="handleResultSuccess"
    />

    <!-- 备注抽屉 -->
    <el-drawer
      title="订单备注"
      :visible.sync="notesDrawerVisible"
      direction="rtl"
      size="600px"
      :before-close="handleDrawerClose">
      <div style="padding: 20px;">
        <OrderNotesDrawer
          :notes="currentOrderNotes"
          :orderSn="currentOrderSn"
          :currentScene="currentScene"
          :showDebug="false"
          @note-updated="handleNoteUpdated" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getOrdRefundNestedPage, confirmPutIn } from '../../api/OrdRefund'
import { deleteOrdRefund } from '../../api/ErpOrder'
import { getAllEnabledShops } from '../../api/SysShop'
import Pagination from '../../components/Pagination'
import DictSelect from '../../components/DictSelect'
import DictTableColumn from '../../components/DictTableColumn'
import DictTag from '../../components/DictTag'
import OrdRefundEdit from './OrdRefundEdit'
import OrdRefundResultEdit from './OrdRefundResultEdit'
import NoteColumn from '../../components/NoteColumn'
import OrderNotesDrawer from './OrderNotesDrawer'
import UserSelector from '../../components/UserSelector'
import noteDrawerMixin from '../../mixins/noteDrawerMixin'
import copyMixin from '../../mixins/copyMixin'
import qs from 'qs'

export default {
  name: 'OrdRefund',
  mixins: [copyMixin, noteDrawerMixin],
  components: {
    Pagination,
    DictSelect,
    DictTableColumn,
    DictTag,
    OrdRefundEdit,
    OrdRefundResultEdit,
    NoteColumn,
    OrderNotesDrawer,
    UserSelector
  },
  data() {
    return {
      // 搜索表单数据
      formInline: {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStates: ['003'],
        applyStatus: '',
        applyStatusList: [],
        resultStatus: '',
        resultStatusList: [],
        settlementFlag: '',
        settlementFlagList: [],
        resultUserIdList: [],
        resultTimeStart: '',
        resultTimeEnd: '',
        resultTimeRange: [],
        orders: []
      },
      // 表格数据
      tableData: [],
      // 店铺列表
      shopList: [],
      // 选中的填写人列表
      selectedResultUsers: [],
      // 分页数据
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,

      // 退款申请对话框
      refundDialogVisible: false,
      currentRefundData: {},
      isEditRefund: false,

      // 退款结果对话框
      resultDialogVisible: false,

      currentScene: '05',  // 已采购但出库前取消
      expandedRows: []
    }
  },
  created() {
    // 检查URL参数中是否有orderSn
    if (this.$route.query.orderSn) {
      this.formInline.orderSn = this.$route.query.orderSn;
    }
    this.getPageData()
    this.loadShops()
  },
  methods: {
    // API方法
    deleteOrdRefund,

    // 格式化金额，添加千分位逗号
    formatAmount(amount) {
      if (!amount && amount !== 0) return '-'
      const num = parseFloat(amount)
      if (isNaN(num)) return '-'
      return '￥ ' + num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },

    // 获取分页数据
    getPageData(parameter) {
      this.loading = true
      if (!parameter) {
        parameter = {
          current: this.formInline.current,
          size: this.formInline.size,
          shopIds: this.formInline.shopIds && this.formInline.shopIds.length > 0 ? this.formInline.shopIds : undefined,
          orderSn: this.formInline.orderSn || undefined,
          erpPlatform: this.formInline.erpPlatform || undefined,
          orderStates: this.formInline.orderStates && this.formInline.orderStates.length > 0 ? this.formInline.orderStates : undefined,
          applyStatusList: this.formInline.applyStatusList && this.formInline.applyStatusList.length > 0 ? this.formInline.applyStatusList : undefined,
          resultStatusList: this.formInline.resultStatusList && this.formInline.resultStatusList.length > 0 ? this.formInline.resultStatusList : undefined,
          settlementFlagList: this.formInline.settlementFlagList && this.formInline.settlementFlagList.length > 0 ? this.formInline.settlementFlagList : undefined,
          resultUserIdList: this.formInline.resultUserIdList && this.formInline.resultUserIdList.length > 0 ? this.formInline.resultUserIdList : undefined,
          resultTimeStart: this.formInline.resultTimeStart || undefined,
          resultTimeEnd: this.formInline.resultTimeEnd || undefined,
          orders: this.formInline.orders || []
        }
      }

      // 处理日期范围
      if (parameter.resultTimeRange && parameter.resultTimeRange.length === 2) {
        parameter.resultTimeStart = parameter.resultTimeRange[0]
        parameter.resultTimeEnd = parameter.resultTimeRange[1]
      } else {
        parameter.resultTimeStart = parameter.resultTimeStart || undefined
        parameter.resultTimeEnd = parameter.resultTimeEnd || undefined
      }

      getOrdRefundNestedPage(parameter).then(response => {
        this.tableData = response.data.records
        this.pageParam.total = response.data.total
        this.pageParam.currentPage = response.data.current
        this.pageParam.pageSize = response.data.size
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    // 加载店铺列表
    loadShops() {
      getAllEnabledShops().then(response => {
        if (response.success && response.data && response.data.records) {
          this.shopList = response.data.records
        } else {
          this.shopList = []
        }
      }).catch(error => {
        console.error('加载店铺数据失败：', error)
        this.shopList = []
      })
    },

    // 填写人选择回调
    handleResultUserSelect(users) {
      this.selectedResultUsers = users
      this.formInline.resultUserIdList = users.map(user => user.userId)
    },

    // 排序处理
    handleSortChange(column) {
      if (column.order != null) {
        let sortProp = column.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        let orderBy = { "column": sortProp, "asc": column.order === 'ascending' }
        this.formInline.orders[0] = orderBy
      } else {
        this.formInline.orders = []
      }
      this.getPageData()
    },

    // 搜索
    onSearch() {
      this.formInline.current = 1
      this.getPageData()
    },

    // 重置
    onReset() {
      this.formInline = {
        current: 1,
        size: 10,
        shopIds: [],
        orderSn: '',
        erpPlatform: '',
        orderStates: ['003'],
        applyStatus: '',
        applyStatusList: [],
        resultStatus: '',
        resultStatusList: [],
        settlementFlag: '',
        settlementFlagList: [],
        resultUserIdList: [],
        resultTimeStart: '',
        resultTimeEnd: '',
        resultTimeRange: [],
        orders: []
      }
      this.selectedResultUsers = []
      this.getPageData()
    },

    // 分页回调
    callback_getPageData(pageParam) {
      this.formInline.current = pageParam.currentPage
      this.formInline.size = pageParam.pageSize
      this.getPageData()
    },

    // 申请操作
    handleApply(row) {
      this.currentRefundData = { ...row }
      this.isEditRefund = false
      this.refundDialogVisible = true
    },

    // 结果操作
    handleResult(row) {
      this.currentRefundData = { ...row }
      this.resultDialogVisible = true
    },

    // 申请弹窗关闭
    handleRefundDialogClose() {
      this.refundDialogVisible = false
      this.currentRefundData = {}
    },

    // 申请成功
    handleRefundSuccess() {
      this.refundDialogVisible = false
      this.getPageData()
    },

    // 结果弹窗关闭
    handleResultDialogClose() {
      this.resultDialogVisible = false
      this.currentRefundData = {}
    },

    // 结果成功
    handleResultSuccess() {
      this.resultDialogVisible = false
      this.getPageData()
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return '-'
      const dateObj = new Date(date)
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      const hours = String(dateObj.getHours()).padStart(2, '0')
      const minutes = String(dateObj.getMinutes()).padStart(2, '0')
      // const seconds = String(dateObj.getSeconds()).padStart(2, '0')
      // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },

    // 获取行key
    getRowKey(row) {
      return row.orderSn
    },

    // 展开行变化
    handleExpandChange(_, expandedRows) {
      this.expandedRows = expandedRows.map(r => r.orderSn)
    },



    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = '/static/img/default-product.png'
    },

    // 确认入库
    handleConfirmPutIn(row) {
      this.$confirm('确认商品已入库？', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          orderSn: row.orderSn
        }
        confirmPutIn(params).then(() => {
          this.$message.success('确认入库成功')
          this.getPageData()
        }).catch(() => {
          // API调用失败，错误信息已在拦截器中处理
        })
      }).catch(() => {
        // 用户取消操作
      })
    },

    // 删除退款记录
    handleDelete(row) {
      this.$confirm('确定要删除这条退款记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          idList: [row.orderSn]
        }
        this.deleteOrdRefund(params).then(() => {
          this.$message.success('删除成功')
          this.getPageData()
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 子表格操作方法
    handleItemApply(item) {
      // 将订单明细数据转换为处理弹窗需要的格式，包含所有商品信息
      const refundData = {
        orderItemId: item.orderItemId,
        orderSn: item.orderSn,
        // 商品信息
        itemName: item.itemName,
        itemModelName: item.itemModelName,
        itemImage: item.itemImage,
        amount: item.amount,
        // 采购信息
        purchaseChannel: item.purchaseChannel,
        purchaseAmount: item.purchaseAmount,
        purchaseDate: item.purchaseDate,
        // 申请状态信息
        applyStatus: item.applyStatus,
        applyAmount: item.applyAmount,
        applyDetail: item.applyDetail,
        applyTime: item.applyTime,
        applyUserId: item.applyUserId
      }
      this.handleApply(refundData)
    },

    handleItemResult(item) {
      const refundData = {
        orderItemId: item.orderItemId,
        orderSn: item.orderSn,
        applyStatus: item.applyStatus,
        applyAmount: item.applyAmount, // 添加申请退款金额
        resultStatus: item.resultStatus,
        settlementFlag: item.settlementFlag
      }
      this.handleResult(refundData)
    },

    handleItemConfirmPutIn(item) {
      this.$confirm('确认商品已入库？', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          orderItemId: item.orderItemId
        }
        confirmPutIn(params).then(() => {
          this.$message.success('确认入库成功')
          this.getPageData()
        }).catch(() => {
          // API调用失败，错误信息已在拦截器中处理
        })
      }).catch(() => {
        // 用户取消操作
      })
    },

    handleItemDelete(item) {
      this.$confirm('确定要删除这条退款记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          idList: [item.orderItemId]
        }
        this.deleteOrdRefund(params).then(() => {
          this.$message.success('删除成功')
          this.getPageData()
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 导出Excel
    handleExport() {
      this.$confirm('确认导出当前查询到的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        const params = { ...this.formInline }
        // 处理日期范围
        if (params.resultTimeRange && params.resultTimeRange.length === 2) {
          params.resultTimeStart = params.resultTimeRange[0]
          params.resultTimeEnd = params.resultTimeRange[1]
        } else {
          params.resultTimeStart = undefined
          params.resultTimeEnd = undefined
        }
        // 添加token
        params.token = localStorage.getItem('logintoken')
        // 参照 Stock.vue 的实现使用 qs.stringify，支持数组等复杂结构
        const query = qs.stringify(params, { allowDots: true, skipNulls: true })
        const url = "/api/ord-refund/nested-download?" + query
        window.open(url)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消导出'
        })
      })
    }
  }
}
</script>

<style scoped>
.content-container {
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.demo-form-inline {
  margin-bottom: 10px;
}

.demo-form-inline .el-form-item {
  margin-bottom: 10px;
}

/* 订单项展开区域样式 */
.order-items-section {
  background-color: #f8f9fa;
  border-radius: 6px;
}

.order-items-section h4 {
  color: #409EFF;
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 2px solid #409EFF;
  padding-bottom: 5px;
}

.price {
  color: #E6A23C;
  font-weight: bold;
}

.express-no {
  color: #67C23A;
  font-weight: bold;
  background-color: #F0F9FF;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #67C23A;
}

.no-express {
  color: #909399;
  font-style: italic;
}

.clickable-express {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-express:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

/* 商品名称复制样式 */
.clickable-item-name {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-item-name:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

/* 商品名称单元格样式 */
.item-name-cell {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.item-name-cell:hover {
  background-color: #f5f7fa;
}

.item-name-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 商品详情弹窗样式 */
.item-preview-content {
  display: flex;
  gap: 12px;
}

.item-image-section {
  flex-shrink: 0;
}

.item-info-section {
  flex: 1;
  min-width: 0;
}

.item-detail-row {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.item-detail-row:last-child {
  margin-bottom: 0;
}

.item-label {
  font-weight: 500;
  color: #606266;
  min-width: 70px;
  flex-shrink: 0;
}

.item-value {
  color: #303133;
  word-break: break-all;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/order/OrdRefund.vue